// extracted by mini-css-extract-plugin
module.exports = {"Canvas":"ProjectCanvas_Canvas__3xh5W"};